import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';

export const CONTENT_TYPE = {
  CSV: 'text/csv',
  JSON: 'application/json',
  TEXT: 'text/plain',
};

export const HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  EXPIRES: 'Expires',
  CONTENT_DISPOSITION: 'Content-Disposition',
};

export const TARGET_TYPE = {
  VIDEO: 'video',
  THUMBNAIL: 'thumbnail',
};

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
};

export const ENDPOINT = {
  AUTH: `${import.meta.env.VELA_AUTH_API_ENDPOINT}/api/v1`,
  AUTH_V2: `${import.meta.env.VELA_AUTH_API_ENDPOINT}/api/v2`,
  AUTH_V3: `${import.meta.env.VELA_AUTH_API_ENDPOINT}/api/v3`,
  BULK_OVERRIDE: import.meta.env.VELA_BULK_OVERRIDE_API_ENDPOINT,
  CONNECT_CHANNEL: {
    [EBAY]: `${import.meta.env.VELA_WEB_API_ENDPOINT}/api/v2/ebay/getUserAuth`,
    [ETSY]: `${import.meta.env.VELA_WEB_API_ENDPOINT}/auth/etsy`,
    [FAIRE]: `${import.meta.env.VELA_WEB_API_ENDPOINT}/api/v2/faire/getUserAuth`,
    [SHOPIFY]: `${import.meta.env.VELA_WEB_API_ENDPOINT}/shopifyAppStore`,
  },
  ACTIVATE_VELA_CHANNEL: {
    [EBAY]: 'https://signup.ebay.com/pa/crte',
    [ETSY]: 'https://www.etsy.com/join',
    [FAIRE]: 'https://www.faire.com/brands',
    [SHOPIFY]: 'https://accounts.shopify.com/signup',
  },
  CSV: import.meta.env.VELA_CSV_API_ENDPOINT,
  IMAGE_GROUPING: import.meta.env.VELA_IMAGE_GROUPING_API_ENDPOINT,
  LOGOUT: `${import.meta.env.VELA_WEB_API_ENDPOINT}/logout`,
  MEDIA_SERVICE: `${import.meta.env.VELA_MEDIA_SERVICE_API_ENDPOINT}/api/v1`,
  S3_ASSETS_BUCKET: import.meta.env.VELA_ASSETS_BUCKET_ENDPOINT,
  S3_FILES_BUCKET: import.meta.env.VELA_FILES_BUCKET_ENDPOINT,
  S3_IMAGES_BUCKET: import.meta.env.VELA_IMAGES_BUCKET_ENDPOINT,
  S3_TAXONOMY_BUCKET: import.meta.env.VELA_TAXONOMY_BUCKET_ENDPOINT,
  S3_THUMBNAILS_BUCKET: import.meta.env.VELA_THUMBNAILS_BUCKET_ENDPOINT,
  S3_VIDEOS_BUCKET: import.meta.env.VELA_VIDEOS_BUCKET_ENDPOINT,
  SCHEDULED_UPDATES: import.meta.env.VELA_SCHEDULED_UPDATES_API_ENDPOINT,
  SCHEDULED_LISTINGS: import.meta.env.VELA_SCHEDULED_LISTINGS_API_ENDPOINT,
  UPDATE_TOKEN: `${import.meta.env.VELA_WEB_API_ENDPOINT}/auth/shopify`,
  WEB: `${import.meta.env.VELA_WEB_API_ENDPOINT}/api/v1`,
  WEB_V2: `${import.meta.env.VELA_WEB_API_ENDPOINT}/api/v2`,
  WEB_V3: `${import.meta.env.VELA_WEB_API_ENDPOINT}/api/v3`,
};

export const ERROR_KEYS = [
  'message',
  'error_message',
  'error',
  'reason',
  'data',
];
